"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeFactory = void 0;

var ActivityLog_1 = require("./ActivityLog");

var AppVersion_1 = require("./AppVersion");

var EFx_1 = require("./EFx");

var EmailDesign_1 = require("./EmailDesign");

var EmailMessage_1 = require("./EmailMessage");

var EmailTemplate_1 = require("./EmailTemplate");

var Event_1 = require("./Event");

var Group_1 = require("./Group");

var HealthPass_1 = require("./HealthPass");

var Import_1 = require("./Import");

var Integration_1 = require("./Integration");

var IntegrationFieldMapping_1 = require("./IntegrationFieldMapping");

var IntegrationStatusMapping_1 = require("./IntegrationStatusMapping");

var Invitation_1 = require("./Invitation");

var Lead_1 = require("./Lead");

var Link_1 = require("./Link");

var Mobile_1 = require("./Mobile");

var Payment_1 = require("./Payment");

var Pool_1 = require("./Pool");

var Profile_1 = require("./Profile");

var Promotion_1 = require("./Promotion");

var Question_1 = require("./Question");

var Queue_1 = require("./Queue");

var Region_1 = require("./Region");

var Report_1 = require("./Report");

var Salesforce_1 = require("./Salesforce");

var Salutation_1 = require("./Salutation");

var SitePage_1 = require("./SitePage");

var Stack_1 = require("./Stack");

var TicketBlock_1 = require("./TicketBlock");

var User_1 = require("./User");

var Venue_1 = require("./Venue");

var Virbela_1 = require("./Virbela");

var WebConference_1 = require("./WebConference");

var TypeFactory =
/** @class */
function () {
  function TypeFactory() {}

  TypeFactory.prototype.ActivityLog = function () {
    return new ActivityLog_1.ActivityLog();
  };

  TypeFactory.prototype.AppVersion = function () {
    return new AppVersion_1.AppVersion();
  };

  TypeFactory.prototype.EFx = function () {
    return new EFx_1.EFx();
  };

  TypeFactory.prototype.EmailDesign = function () {
    return new EmailDesign_1.EmailDesign();
  };

  TypeFactory.prototype.EmailMessage = function () {
    return new EmailMessage_1.EmailMessage();
  };

  TypeFactory.prototype.EmailTemplate = function () {
    return new EmailTemplate_1.EmailTemplate();
  };

  TypeFactory.prototype.Event = function () {
    return new Event_1.Event();
  };

  TypeFactory.prototype.Group = function () {
    return new Group_1.Group();
  };

  TypeFactory.prototype.HealthPass = function () {
    return new HealthPass_1.HealthPass();
  };

  TypeFactory.prototype.Import = function () {
    return new Import_1.Import();
  };

  TypeFactory.prototype.Integration = function () {
    return new Integration_1.Integration();
  };

  TypeFactory.prototype.IntegrationFieldMapping = function () {
    return new IntegrationFieldMapping_1.IntegrationFieldMapping();
  };

  TypeFactory.prototype.IntegrationStatusMapping = function () {
    return new IntegrationStatusMapping_1.IntegrationStatusMapping();
  };

  TypeFactory.prototype.Invitation = function () {
    return new Invitation_1.Invitation();
  };

  TypeFactory.prototype.Lead = function () {
    return new Lead_1.Lead();
  };

  TypeFactory.prototype.Link = function () {
    return new Link_1.Link();
  };

  TypeFactory.prototype.Mobile = function () {
    return new Mobile_1.Mobile();
  };

  TypeFactory.prototype.Payment = function () {
    return new Payment_1.Payment();
  };

  TypeFactory.prototype.Pool = function () {
    return new Pool_1.Pool();
  };

  TypeFactory.prototype.Profile = function () {
    return new Profile_1.Profile();
  };

  TypeFactory.prototype.Promotion = function () {
    return new Promotion_1.Promotion();
  };

  TypeFactory.prototype.Question = function () {
    return new Question_1.Question();
  };

  TypeFactory.prototype.Queue = function () {
    return new Queue_1.Queue();
  };

  TypeFactory.prototype.Region = function () {
    return new Region_1.Region();
  };

  TypeFactory.prototype.Report = function () {
    return new Report_1.Report();
  };

  TypeFactory.prototype.Salesforce = function () {
    return new Salesforce_1.Salesforce();
  };

  TypeFactory.prototype.Salutation = function () {
    return new Salutation_1.Salutation();
  };

  TypeFactory.prototype.SitePage = function () {
    return new SitePage_1.SitePage();
  };

  TypeFactory.prototype.Stack = function () {
    return new Stack_1.Stack();
  };

  TypeFactory.prototype.TicketBlock = function () {
    return new TicketBlock_1.TicketBlock();
  };

  TypeFactory.prototype.User = function () {
    return new User_1.User();
  };

  TypeFactory.prototype.Venue = function () {
    return new Venue_1.Venue();
  };

  TypeFactory.prototype.Virbela = function () {
    return new Virbela_1.Virbela();
  };

  TypeFactory.prototype.WebConference = function () {
    return new WebConference_1.WebConference();
  };

  return TypeFactory;
}();

exports.TypeFactory = TypeFactory;